import React from 'react';

const Header = () => (
    <div className="login-box-logo">
        <img src="/images/white_logo_nvbdc.png" alt="Dashboard" />
    </div>
)

export default Header;



// WEBPACK FOOTER //
// ./src/layouts/public/header/Header.js